export default {
    test: {},
    prod: {
        //baseURL: "http://127.0.0.1/",
        // baseURL: "https://jzb.jianzhibei.cn/",
        baseURL: "https://api.jianzhibei.cn/",
        wsURL:"ws://81.70.78.15:9502"
    }
}